<template>
  <div>
      <section>
        <ManageUsersTable :items="users" v-if="users"></ManageUsersTable>
      </section>
  </div>
</template>

<script>
  import axios from 'axios'
  import ManageUsersTable from "../../util/ManageUsers/ManageUsersTable";

  // @vuese
  // Page allowing you to manage the users' information and their permission on the portal.
  // @group Manage Users
  export default {
    name: "ManageUsers",
    components: {ManageUsersTable},
    data() {
      return {
      }
    },
    methods: {
    },
    asyncComputed: {
      async users() {
        return await axios.get(process.env.API_URL + '/users')
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            return [];
          });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/ManageUsers.vue